import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IntegrationsService {
    private baseUrl = `${environment.apiUrl}/Integrations`;
    private baseUrl2 = `${environment.apiUrlV2}/integrations`;
    private baseUrl3 = `${environment.apiUrlV3}/integrations`;
    private baseUrl4 = `${environment.apiUrlV2}`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) { }

    getMobyTokenViewInspections(companyPersonId: string) {
        return this.http
            .get<any>(`${this.baseUrl}/Mobi/ReportView/Token/${companyPersonId}`, {
                headers: this.headers,
                observe: 'response',
            })
            .toPromise();
    }

    newGetMobyTokenViewInspections(companyPersonId: string) {
        return this.http
            .get<any>(`${this.baseUrl}/Mobi/ReportView/Token/${companyPersonId}`, {
                headers: this.headers,
                observe: 'response',
            });
    }
}
